import React from 'react';
// import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import { Panel } from 'react-bootstrap';
import Switch from 'react-bootstrap-switch';
import { Link } from 'react-router-dom'

import EmbedStringGenerator from '../../../../../embed/lib/EmbedStringGenerator';
import Preference from '../../../../../embed/player/Preference';

import InternalHosting from './InternalHosting';
import DocLink from '../../../../../docs/DocLink';

import LargeToolTip from "../../../../../account/components/LargeToolTip";
import InfoIcon from '@material-ui/icons/Info';

var Preferences = createReactClass({
    getInitialState: function () {
        return {
            renderMode: "script",
            forceBasic: false
        };
    },

    handleBasicChange: function (event) {
        this.setState({
            forceBasic: !this.state.forceBasic
        });
    },

    handleEmbedToggle: function () {
        this.setState({
            renderMode: (this.state.renderMode == 'script') ?
                'iframe' :
                'script'
        });
    },

    handlePreferenceAssign: function (id) {
        this.props.actions.editEvent({
            eventID: this.props.event.eventID,
            playerPrefID: id
        });
    },

    handleBreakOverride: function (breakOverride) {
        this.props.actions.editEvent({
            eventID: this.props.event.eventID,
            breakOverride,
        });
    },

    render: function () {
        var { event, mode, preferences, actions, clientID } = this.props;

        var eventIsPast = !!(
            mode === 'event' &&
            event &&
            event.startDateTime &&
            new Date(event.startDateTime).getTime() < Date.now()
        );

        if (!preferences.data.length) {
            return <div className="alert alert-info">
                <h4>No Player Preferences Found</h4>
                <p>
                    <Link className="btn btn-default" to="/manage/player/edit">
                        Create one here &hellip;
                    </Link>
                </p>
            </div>
        }

        return (
            <div id="event-preference-listing">

                <Panel>
                    <Panel.Heading>
                        {this.renderHeader()}
                    </Panel.Heading>

                    <Panel.Body>
                        <label>Share</label>
                        <InternalHosting
                            {...this.props}
                            forceBasic={this.state.forceBasic}
                            renderMode="hosted"
                            domain="player"/>

                        <hr/>

                        <label>Embed</label>
                        <EmbedStringGenerator
                            eventID={event.eventID}
                            forceBasic={this.state.forceBasic}
                            renderMode={this.state.renderMode}
                            clientID={clientID}
                            domain="player"/>
                    </Panel.Body>
                </Panel>

                <Panel>
                    <Panel.Heading>
                        <Panel.Title>
                            <h4 style={{paddingLeft: "15px"}}>Options</h4>
                        </Panel.Title>
                    </Panel.Heading>
                    
                    <Panel.Body>
                        <div className="col-md-4" style={{display: "flex", flexDirection: "column"}}>
                            <label>Break Override
                                <LargeToolTip title="will continue to display the stream source while on break" >
                                    <InfoIcon style={{color:'#5252c6',fontSize:20,marginBottom:'-5px',marginLeft:'5px'}}/>
                                </LargeToolTip>
                            </label>
                            
                            <Switch value={event.breakOverride} animate={false} onChange={(_, newValue) => this.handleBreakOverride(newValue)} />
                        </div>
                    </Panel.Body>
                </Panel>


                <hr/>

                <h4>Preferences:</h4>

                {preferences.data.map(function (pref) {
                    var { prefID, playerPref } = pref;
                    return (<Preference
                        key={'player-preference-' + prefID}
                        event={event}
                        eventIsPast={eventIsPast}
                        mode={mode}
                        preferenceID={prefID}
                        isDefault={pref.default}
                        preference={playerPref}
                        actions={actions}
                        clientID={clientID}
                        handlePreferenceAssign={this.handlePreferenceAssign.bind(null, prefID)}
                    />);
                }, this)}
            </div>
        );
    },

    renderHeader: function () {
        var toggleProps = {
            value: (this.state.renderMode == "script") ? true : false,
            bsSize: 'small',
            onText: 'Script Tag',
            offText: 'iFrame',
            animate: false,
            onChange: this.handleEmbedToggle
        };

        return (<div className="clearfix">
            <div className="col-md-6">
                <h4>Embed &amp; Share</h4>
            </div>
            <div className="col-md-6 text-right">
                <label style={{ marginRight: '1rem' }}>
                    <input
                        type="checkbox"
                        checked={this.state.forceBasic}
                        onChange={this.handleBasicChange}
                    /> Media Player Only
                </label>

                <Switch {...toggleProps}/>
                <DocLink
                    path="https://invintus-support.freshdesk.com/a/solutions/articles/48001173663"
                    style={{verticalAlign:'super', marginLeft:'0.5em'}}
                />
            </div>
        </div>);
    }
});

export default Preferences;
